parseTokenHHMMSS